// extracted by mini-css-extract-plugin
export default {"inputNumber":"AppInputNumber_inputNumber__jF+wU","smallTextError":"AppInputNumber_smallTextError__5uQdC"};